/** PostgREST schema-cache error for a missing competitions column. */
export function parseMissingCompetitionColumn(error) {
  const msg = String(error?.message || '');
  const m = msg.match(/Could not find the '([^']+)' column of 'competitions'/i);
  return m?.[1] || null;
}

export function isCompetitionSchemaColumnError(error) {
  return Boolean(parseMissingCompetitionColumn(error));
}

/**
 * Insert a competition row, dropping unknown columns if the DB is behind
 * on migrations (retries until insert succeeds or a non-schema error occurs).
 */
export async function insertCompetitionRow(supabase, payload) {
  let attempt = { ...payload };

  for (let i = 0; i < 12; i++) {
    const { data, error } = await supabase.from('competitions').insert(attempt).select().single();
    if (!error) return { data, error: null };

    const missing = parseMissingCompetitionColumn(error);
    if (!missing || !(missing in attempt)) {
      return { data: null, error };
    }

    console.warn(`[competitions] dropping unknown column "${missing}" and retrying insert`);
    const next = { ...attempt };
    delete next[missing];
    attempt = next;
  }

  return {
    data: null,
    error: { message: 'Competition insert failed after stripping unknown columns.' },
  };
}

/** Strip optional keys from an update payload when a column is missing. */
export function stripMissingCompetitionColumn(payload, column) {
  if (!column || !(column in payload)) return payload;
  const next = { ...payload };
  delete next[column];
  return next;
}

/**
 * Update a competition row, dropping unknown columns if the DB is behind
 * on migrations (retries until update succeeds or a non-schema error occurs).
 */
export async function updateCompetitionRow(supabase, competitionId, payload) {
  let attempt = { ...payload };

  for (let i = 0; i < 12; i++) {
    const { error } = await supabase.from('competitions').update(attempt).eq('id', competitionId);
    if (!error) return { error: null };

    const missing = parseMissingCompetitionColumn(error);
    if (!missing || !(missing in attempt)) {
      return { error };
    }

    console.warn(`[competitions] dropping unknown column "${missing}" and retrying update`);
    attempt = stripMissingCompetitionColumn(attempt, missing);
  }

  return { error: { message: 'Competition update failed after stripping unknown columns.' } };
}
